import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { VentaAnimalesService } from "../../../../generated/grpc/pesaje_ganaderia_pb";
import { grpcVentaAnimalesDatabase } from "../database/GrpcVentaAnimalesDatabase";
import { VentaAnimalesRequest } from "../request/VentaAnimalesRequest";
import { VentaAnimalesResponse } from "../response/VentaAnimalesResponse";
import { fx_aplicarCambiosMovimientoAsync } from "./aplicarCambiosMovimiento";
import { toVentaAnimalesResponse } from "./VentaAnimalesGrpcService";

/** Variante gRPC-Web de `VentaAnimalesSaveService` (ver ese archivo): mismo
 *  guardado crear-o-actualizar. Escribe además los lotes y las compras que el
 *  server recalculó, que vienen en la misma respuesta -ver
 *  `fx_aplicarCambiosMovimientoAsync`- (2026-10-08). */
export class VentaAnimalesSaveGrpcService
  implements ISaveService<VentaAnimalesRequest, VentaAnimalesResponse>
{
  async saveAsync(request: VentaAnimalesRequest): Promise<VentaAnimalesResponse> {
    const client = createClient(VentaAnimalesService, grpcTransportProvider.get());

    let respuesta;
    try {
      respuesta = await client.guardar({
        id: request.id ?? undefined,
        loteSalidaId: request.loteSalidaId,
        fechaVenta: request.fechaVenta,
        precioKilo: request.precioKilo,
        pesosAnimales: request.pesosAnimales,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const saved = respuesta.venta;
    if (!saved) {
      throw new Error("El servidor no devolvió la venta guardada.");
    }

    await grpcVentaAnimalesDatabase.putOneAsync(saved);
    await fx_aplicarCambiosMovimientoAsync(respuesta);
    return toVentaAnimalesResponse(saved);
  }
}
